// extracted by mini-css-extract-plugin
export default {"button":"button_button__yn2Bn","hollow":"button_hollow__FOXzb"};